export const INVOICE_NOTIFIER_ERROR_INVALID_FILE = 601;
export const INVOICE_NOTIFIER_ERROR_INVALID_FILE_TYPE = 602;
export const INVOICE_NOTIFIER_ERROR_INVALID_FILE_CSV_HEADER = 603;
export const INVOICE_NOTIFIER_ERROR_INVALID_WINNING_INVOICE_RECORD = 604;
export const INVOICE_NOTIFIER_ERROR_CONFLICT = 49;
